$( document ).ready(function() {

  // // move currency selectors to announcement bar
  // setTimeout(function() { 
  //  $('.locale-selectors__container').prependTo("#shopify-section-sections--16756781449471__announcement-bar");
  //  $('#LocalizationForm').appendTo("#nav-drawer"); 

  //   // only show  five currencies instead of all
  //   $("#country_code option").attr("hidden", "true");
  //   $("#country_code option[value='US']").removeAttr("hidden");
  //   $("#country_code option[value='AU']").removeAttr("hidden");
  //   $("#country_code option[value='CA']").removeAttr("hidden");
  //   $("#country_code option[value='DE']").removeAttr("hidden");
  //   $("#country_code option[value='GB']").removeAttr("hidden");

  //   $(".select-popout__item").hide();
  //   $(".select-popout__option[data-value='USD'").parent().show();
  //   $(".select-popout__option[data-value='AUD'").parent().show();
  //   $(".select-popout__option[data-value='CAD'").parent().show();
  //   $(".select-popout__option[data-value='EUR'").parent().show();
  //   $(".select-popout__option[data-value='GBP'").parent().show();

  //   // change names
    
  //   $("#country_code option[value='US']").text("USD $");
  //   $("#country_code option[value='AU']").text("AUD $");
  //   $("#country_code option[value='CA']").text("CAD $");
  //   $("#country_code option[value='DE']").text("EUR €");
  //   $("#country_code option[value='GB']").text("GBP £");

  //   $("#locale_code option[value='en']").text("EN");
  //   $("#locale_code option[value='fr']").text("FR");
    
  //   $('.locale-selectors__container').addClass('locale-selectors__container--visible');
  // }
  // , 2000);

  


  

  var item = $('.navtext');
  for (var i = 0; i <= item.length; i++) {
   if ($(item[i]).text() == 'View All') {
         $(item[i]).addClass('highlight');
         //do some other stuff here
      }
  }

  var item = $('.navtext');
  for (var i = 0; i <= item.length; i++) {
   if ($(item[i]).text() == 'Voir Tout') {
         $(item[i]).addClass('highlight');
         //do some other stuff here
      }
  }


  let lastWednesday = new Date();
  lastWednesday.setDate(lastWednesday.getDate() - (lastWednesday.getDay() + 4) % 7);
  $('#date').html("Last updated " + lastWednesday);
  
  //var date = (new Date()).toISOString().split('T')[0];
  //$('#date').html("Last updated " + date);

  
});




// PDP - coloring the even and odd sections
var evenOdd = 0;

setTimeout(function() { 
  $(".template-product #MainContent .shopify-section").not(".template-product #MainContent #shopify-section-template--16921132990719__a268a54d-9465-4101-83e0-404d98bb9702").each(function() {  
    
    if($(this).css('display') == 'none') {
       // skip
    }
  
    else if($(this).height() < 300) {
      // skip
    }

      
    else {
      $(this).css("background", ( evenOdd ? "#FFFFFF" : "#FAF7F0" ));
      $(this).children().css("background", ( evenOdd ? "#FFFFFF" : "#FAF7F0" ));
      evenOdd = !evenOdd;
    }
  });
}
, 1000);

setTimeout(function() { 
$('#shopify-section-template--16921132990719__a268a54d-9465-4101-83e0-404d98bb9702').css("background","#FFF");
}
, 1100);


// PDP - hide customer makes if less than 6 images
var numberUGC = $('.ugc img').length;
if (numberUGC >= 6) {
  // great!
}

else {
  $('#shopify-section-template--16756788723967__f73cab66-9cd5-4d6f-9438-aa961edb20bd').hide();
}

/*
// HOME PAGE - Randomize collection list section
document.addEventListener('DOMContentLoaded', function() {
   // Fisher-Yates (Knuth) Shuffle algorithm
   function shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }

    // Get the parent container and its child elements
    const parentContainer = document.querySelector('.template-index .collection-list .grid');
    const elements = parentContainer.children;

    // Convert child elements to an array and shuffle them
    const elementsArray = Array.from(elements);
    const shuffledArray = shuffleArray(elementsArray);

    // Append the shuffled elements back to the parent container in the new order
    shuffledArray.forEach((element) => {
        parentContainer.appendChild(element);
    });

    // Determine how many elements you want to keep visible
    const visibleCount = 24;

    // Hide the elements that you want to hide
    for (let i = visibleCount; i < shuffledArray.length; i++) {
        shuffledArray[i].style.display = 'none';
    }
});

// Collection list navigation arrows
const collectionListCtr = document.querySelector('.template-index .collection-list .grid__container');
const clArrowLeft = document.getElementById('arrowLeft');
const clArrowRight = document.getElementById('arrowRight');

$(clArrowLeft).hide();

clArrowLeft.addEventListener('click', function() {
    collectionListCtr.scrollBy({ left: -300, behavior: 'smooth' });
});

clArrowRight.addEventListener('click', function() {
    collectionListCtr.scrollBy({ left: 300, behavior: 'smooth' });
    $(clArrowLeft).show();
});
*/

// Featured blog navigation arrows
const featuredBlogCtr = document.querySelector('.featured-blog-post-section .featured-blog__container');
const fbArrowLeft = document.getElementById('blogArrowLeft');
const fbArrowRight = document.getElementById('blogArrowRight');

$(fbArrowLeft).hide();

fbArrowLeft.addEventListener('click', function() {
    featuredBlogCtr.scrollBy({ left: -300, behavior: 'smooth' });
});

fbArrowRight.addEventListener('click', function() {
    featuredBlogCtr.scrollBy({ left: 300, behavior: 'smooth' });
    $(fbArrowLeft).show();
});



var stringToHTML = function (str) {
var parser = new DOMParser();
var doc = parser.parseFromString(str, 'text/html');
return doc.body;
};


// Language/country and currency selector functionaltity for selectors outside of footer
const selectBtns = document.querySelectorAll('.country-currency-ctr .select-popout__toggle');
const selectOptions = document.querySelectorAll('.country-currency-ctr .select-popout__option');
const selectorForm = document.querySelector('.country-currency-ctr form');


selectBtns.forEach(btn => {
  btn.addEventListener('click', function() {
    if(btn.getAttribute('aria-expanded') == 'false') {
      btn.setAttribute('aria-expanded', 'true');
      btn.nextElementSibling.classList.add('select-popout__list--visible');
    } else if (btn.getAttribute('aria-expanded') == 'true') {
      btn.setAttribute('aria-expanded', 'false');
      btn.nextElementSibling.classList.remove('select-popout__list--visible');
    }
  })
})

selectOptions.forEach(option => {
  option.addEventListener('click', function(evt) {
    evt.preventDefault();
    
    let attrValueSelected = evt.currentTarget.getAttribute('data-value');
    
    selectorForm.action = `${attrValueSelected}`;
    selectorForm.submit();
    
  })
})

